import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=9521102e&scoped=true&"
import script from "./Ads.vue?vue&type=script&lang=js&"
export * from "./Ads.vue?vue&type=script&lang=js&"
import style0 from "./Ads.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Ads.vue?vue&type=style&index=1&id=9521102e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9521102e",
  null
  
)

export default component.exports